import { faChalkboardTeacher } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import styles from './MandatoryText.module.scss'

export const MandatoryText = () => {
  const { t } = useTranslation()
  return (
    <div className={`d-flex ${styles.mandatoryContainer}`}>
      <p className={styles.mandatory}>
        {' '}
        {t('lessons.contentBlocks.mandatory')}
      </p>
      <FontAwesomeIcon size={'xs'} icon={faChalkboardTeacher} />
    </div>
  )
}
